// extracted by mini-css-extract-plugin
export default {"main__area":"Main_main__area__AAC+N","main__area__not_content":"Main_main__area__not_content__xrT9c"};